module.exports = __webpack_public_path__ + "img/customers.738ea0d8.png";